import { toFixedNonZero } from 'helpers/numberFormat';

export const formatSupplierPublicEmissions = (value) =>
  value === null || value === undefined || Number.isNaN(value) ? '—' : toFixedNonZero(value, 4);

export const SUPPLIER_PUBLIC_NOT_AVAILABLE_TITLE = "This page isn't available";
export const SUPPLIER_PUBLIC_NOT_AVAILABLE_SUBTITLE =
  "The link may be out of date, or the supplier hasn't made this portal public.";
